export const typography = {
  fontFamily: '"Inter",sans-serif',
  h1: {
    fontSize: '2rem',
    fontWeight: 700
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 700
  },
  h3: {},
  h4: {},
  h5: {},
  h6: {}
}
